export default __webpack_public_path__ + "static/media/offer-vertical-chocolate@3x.fc9aa3bd.png";